<template>
  <div class="Recruit">
    <Head></Head>

    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="dqwz">当前位置：</el-breadcrumb-item>
      <el-breadcrumb-item class="home" :to="{ path: '/' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item class="zpgg">{{ navname }}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row class="tac">
      <Process></Process>
      <!-- 右边内容 -->
      <el-col :span="18" class="conter" v-if="list.length>0">
        <div class="Recruit_box">
          <div class="Recruit_box_title">
            <div class="title_top"><span>丨</span><span>{{ navname }}</span></div>
            <div>发布时间</div>
          </div>
          <div class="Recruit_box_article">
            <ul>
              <!-- 红色字体class为class="colo" -->
              <li
                v-for="(item, index) in list"
                :key="index"
                :class="[item.is_show_red_words == '1' ? 'colo' : '']"
              >
                <a :href="'/#/Article?id='+item.id" :title="item.name">{{ item.name }}</a>
                <span>{{ item.release_time }}</span>
              </li>
            </ul>
            <div :class="[{ hide: isPageHide }]">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :currentPage="currentPage"
                  :page-size="pageSize"
                  layout="prev, pager, next, jumper"
                  :total="total"
                >
                </el-pagination>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
import Process from "./Process";
export default {
  props: {},
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      isPageHide: 0,
      navid: 0,
      navname: "",
    };
  },
  computed: {},
  created() {},
  mounted() {
    var query=this.$route.query;
    this.navid = query.navid;
    this.navname = query.name;
    this.getList(1);
  },
  watch: {
    '$route' () {
      this.navid = this.$route.query.navid;
      this.navname = this.$route.query.name;
      this.getList(1);
    }
  },
  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList(val);
    },
    getList(pageid) {
      let _this = this;
      var navid = _this.navid
      _this.request("/api/index/list", { nav_id: navid, page: pageid }, "get").then((res) => {
        if (res.data.status == "success") {
          _this.list = res.data.data.message_list.data;
          _this.currentPage = res.data.data.message_list.current_page;
          _this.total = res.data.data.message_list.total;
          _this.pageSize = res.data.data.message_list.per_page;
          if (res.data.data.message_list.data.length==0) {
            _this.isPageHide = 1;
          }
        }
      });
    },
  },
  components: {
    Head,
    Footer,
    Process,
  },
};
</script>

<style lang="less" scoped>
.hide{display: none}
.Recruit {
  .el-breadcrumb {
    font-size: 0.33rem;
    padding: 0.28rem 1rem;
  }
  .tac {
    margin-top: 1rem;
    margin-bottom: 2rem;
    .conter {
      .Recruit_box {
        padding: 0 0.5rem;
        .Recruit_box_title {
          display: flex;
          justify-content: space-between;
          .title_top {
            span {
              font-size: 0.42rem;
              color: #000;
            }
            span:nth-of-type(1) {
              color: #00a0e9;
            }
          }
          div {
            font-size: 0.33rem;
            color: #565555;
            text-align: center;
          }
        }
        .Recruit_box_article {
          ul {
            padding-top: 0.4rem;
            li {
              font-size: 0.37rem;
              margin-left: 0.5rem;
              padding: 0.3rem 0;
              list-style: disc;
              color: #00a0e9;
              a {
                float: left;
                max-width: 10rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }
              span {
                color: #000;
                text-align: center;
                float: right;
              }
            }
            .colo {
              color: red;
              a {
                color: red;
              }
              span {
                color: red;
              }
            }
          }
          .el-pagination {
            margin-top: 1rem;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
